<script setup lang="ts">
defineProps<{
  open: boolean
  title?: string
  message: string
  confirmLabel?: string
  cancelLabel?: string
  variant?: 'danger' | 'warning' | 'primary'
  busy?: boolean
}>()

defineEmits<{
  (e: 'confirm'): void
  (e: 'cancel'): void
}>()
</script>

<template>
  <dialog :open="open" class="modal" data-testid="confirm-dialog">
    <div class="modal-box max-w-md">
      <div class="flex items-start gap-3 mb-3">
        <div
          class="w-10 h-10 rounded-full flex items-center justify-center shrink-0"
          :class="
            variant === 'danger' ? 'bg-error/20 text-error' :
            variant === 'warning' ? 'bg-warning/20 text-warning' :
            'bg-primary/20 text-primary'
          "
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
        </div>
        <div class="flex-1">
          <h3 v-if="title" class="font-bold text-lg mb-1">{{ title }}</h3>
          <p class="text-sm text-base-content/80 break-words">{{ message }}</p>
        </div>
      </div>

      <div class="modal-action">
        <button
          class="btn btn-ghost"
          :disabled="busy"
          data-testid="confirm-cancel"
          @click="$emit('cancel')"
        >
          {{ cancelLabel ?? 'Cancel' }}
        </button>
        <button
          class="btn"
          :class="
            variant === 'danger' ? 'btn-error' :
            variant === 'warning' ? 'btn-warning' :
            'btn-primary'
          "
          :disabled="busy"
          data-testid="confirm-ok"
          @click="$emit('confirm')"
        >
          <span v-if="busy" class="loading loading-spinner loading-sm"></span>
          <span v-else>{{ confirmLabel ?? 'Confirm' }}</span>
        </button>
      </div>
    </div>
    <div class="modal-backdrop bg-black/50" @click="!busy && $emit('cancel')"></div>
  </dialog>
</template>
